// Load all CSS files in the src directory
import.meta.glob('../css/vendor/*.css', {
    eager: true,
})
import.meta.glob('../css/*.css', {
    eager: true,
})

// Load all JavaScript files in the current directory
import.meta.glob('./vendor/*.js', {
    eager: true,
})
import.meta.glob('./*.js', {
    eager: true,
})

import 'htmx.org'
import './vue/account_menu/index.js'
import './vue/darkmode/index.js'
import './vue/intro/index.js'
import './vue/leaderboard/index.js'
import './vue/timer/index.js'
import './vue/user_profile/index.js'
import './vue/press_detail/index.js'

document.addEventListener('DOMContentLoaded', function () {
    DjangoRealtime.connect({
        endpoint: '/realtime/sse/',
    })
})
